/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ContractorsList_contractors$ref: FragmentReference;
declare export opaque type ContractorsList_contractors$fragmentType: ContractorsList_contractors$ref;
export type ContractorsList_contractors = {|
  +contractorsByOrg: ?{|
    +pageInfo: {|
      +hasNextPage: boolean,
      +hasPreviousPage: boolean,
      +startCursor: ?string,
      +endCursor: ?string,
    |},
    +totalCount: ?number,
    +edgeCount: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +doNotHire: ?boolean,
        +representativeImageUrl: ?string,
        +activeDeliverablesCount: ?number,
        +pastDueDeliverablesCount: ?number,
        +completedDeliverablesCount: ?number,
        +fullName: ?string,
        +lastName: ?string,
        +isActive: ?boolean,
        +inviteStatus: ?string,
        +conflictingContractor: ?{|
          +id: string
        |},
      |}
    |}>,
  |},
  +$refType: ContractorsList_contractors$ref,
|};
export type ContractorsList_contractors$data = ContractorsList_contractors;
export type ContractorsList_contractors$key = {
  +$data?: ContractorsList_contractors$data,
  +$fragmentRefs: ContractorsList_contractors$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ContractorsList_contractors",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "first",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "orderBy",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "after",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "contractorName",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "includeDoNotHire",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "includeInactive",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "inviteStatus",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "country",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "release",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "product",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "tags",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "minCompletedDeliverables",
      "type": "Float"
    },
    {
      "kind": "RootArgument",
      "name": "group",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "contractorsByOrg",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "contractorName",
          "variableName": "contractorName"
        },
        {
          "kind": "Variable",
          "name": "country",
          "variableName": "country"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "group",
          "variableName": "group"
        },
        {
          "kind": "Variable",
          "name": "includeDoNotHire",
          "variableName": "includeDoNotHire"
        },
        {
          "kind": "Variable",
          "name": "includeInactive",
          "variableName": "includeInactive"
        },
        {
          "kind": "Variable",
          "name": "inviteStatus",
          "variableName": "inviteStatus"
        },
        {
          "kind": "Variable",
          "name": "minCompletedDeliverables",
          "variableName": "minCompletedDeliverables"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "product",
          "variableName": "product"
        },
        {
          "kind": "Variable",
          "name": "release",
          "variableName": "release"
        },
        {
          "kind": "Variable",
          "name": "tags",
          "variableName": "tags"
        }
      ],
      "concreteType": "ContractorNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasPreviousPage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "startCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalCount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "edgeCount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ContractorNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractorNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "doNotHire",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "representativeImageUrl",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "activeDeliverablesCount",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "pastDueDeliverablesCount",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "completedDeliverablesCount",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "fullName",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "lastName",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isActive",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "inviteStatus",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "conflictingContractor",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ContractorNode",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '5326e76f0d6b05877ed9c0ce2d4cdcb1';
module.exports = node;
